import PropTypes from "prop-types";

import OurPricingTable, { MobilePricing } from "./OurPricingTable";

import dataJson from "./data.json";

const OurPricing = () => {
  return (
    <div>
      <div className="hidden lg:block">
        <OurPricingTable data={dataJson.dataOurPricing} />
      </div>
      <div className="block lg:hidden">
        <MobilePricing data={dataJson.dataOurPricing} />
      </div>
    </div>
  );
};

export default OurPricing;
OurPricing.propTypes = {
  data: PropTypes.array,
  children: PropTypes.element,
};
OurPricing.defaultProps = {
  data: [],
  children: <></>,
};
